import { WithStyles, withStyles } from '@mui/styles';
import { AccountRecord, FirmRecord } from '@tassat/fred-definitions';
import { UserAccountMapped, WalletRecordMapped } from '@tassat/fred-extended-definitions';

import { FirmWalletDetailsHeader } from './firmWalletDetailsHeader';
import { muiStyles } from './styles';

export interface FirmWalletDetailsHeaderProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
    mappedWallet: WalletRecordMapped;
    allWallets: AccountRecord[];
    wireUserAccounts: UserAccountMapped[];
}

export default withStyles(muiStyles)(FirmWalletDetailsHeader);